import { Modal } from "antd";
import Spinner from "@src/components/spinner";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Confirmation = ({visible, close, message, submit, loading, btnText1="Confirm", btnText2="Cancel"})=>{
    return(
        <Modal
            visible={visible}
            width="min(600px, 92vw)"
            footer={
                <div
                    className="drawer-footer"
                    style={{justifyContent:'flex-end', backgroundColor:'none', padding:'15px 16px'}}
                >

                    <button disabled={loading} style={{minWidth:'20%'}}  className={loading?'disabled-btn drawer-filled-btn ' :'drawer-filled-btn'} onClick={loading? null :submit}>
                       {loading? <Spinner/> : btnText1} 
                    </button>

                    <button disabled={loading}  style={{minWidth:'20%'}} className={loading? 'disabled-btn drawer-outlined-btn' : 'drawer-outlined-btn'} onClick={close}>
                        {btnText2}
                    </button>

                </div>
            }
            closable={false}
        >
            <div className='modal-header-title' style={{height:'auto', minHeight:'2.5em'}}>
                <span style={{letterSpacing:'0.2px'}}> Confirmation </span>
                <span onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
            </div>

            <div className='modal-body modal-body-padding'>
                <div className="text" style={{display:'flex', justifyContent:'center', alignItems:'center', width:'100%', minHeight:'80px', fontSize:'15px', fontWeight:'400', color:'#1e2d3d'}}>{message}</div>
            </div>

        </Modal>
    )
}